import styled, { css } from 'styled-components';

export const Card = styled.div`
    ${({ theme }) => css`
        border-radius: ${theme.v3.border.radius.xl};
        background: linear-gradient(180deg, ${theme.v3.colors.brand.snappyBlue[10]} 0%, ${theme.v3.colors.brand.snappyBlue[40]} 100%);
        padding: 0;
        display: flex;
        font-family: ${theme.v3.font.family.brand};
        color: ${theme.v3.colors.neutral[100]};
        overflow: hidden;
        width: 100%;

        @media (max-width: ${theme.v3.breakpoints.md}) {
            flex-direction: column;            
        }
    `}
`;

export const BlockText = styled.div`
    ${({ theme }) => css`
        display: flex;
        align-self: center;
        flex-direction: column;
        flex: 1;
        padding: 24px;
        width: 100%;

        @media (max-width: ${theme.v3.breakpoints.md}) {
            padding-bottom: 36px;
        }
    `}
`;

export const Title = styled.h3`
    ${({ theme }) => css`
        font-size: ${theme.v3.font.sizes['1xlarge']};
        font-weight: ${theme.v3.font.weights.medium};
        line-height: ${theme.v3.font.lineHeight.comfortable};
        color: ${theme.v3.colors.neutral[100]};
        margin: 0;
    `}
`;

export const Description = styled.p`
    ${({ theme }) => css`
        font-size: ${theme.v3.font.sizes.medium};
        font-weight: ${theme.v3.font.weights.regular};
        line-height: ${theme.v3.font.lineHeight.comfortable};
        color: ${theme.v3.colors.neutral[100]};
        margin: 8px 0 0 0;
        max-width: 550px;

        @media (max-width: ${theme.v3.breakpoints.md}) {
            margin-top: 12px;
        }
    `}
`;

export const Actions = styled.div`
    margin-top: 32px;
`;

export const BlockImage = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
`;

export const Image = styled.img`
    width: 100%;
    max-height: 270px;
    height: -webkit-fill-available;
    margin: 0;
`;
